import type { SxProps, Theme } from '@mui/material/styles';

import { SIDEBAR_DIMENSIONS } from '@/common/presentation/components/layout/sidebarNavConfig';

/** Total layout width budget for sidebar + main content on wide viewports. */
export const PAGE_LAYOUT_MAX_CONTENT_WIDTH = 1920;

/** CSS custom property set on `#main-content` by the shell or host layout from current sidebar width. */
export const PAGE_CONTENT_MAX_WIDTH_CSS_VAR = '--page-content-max-width';

/** Content max width for a given sidebar width (1920 − sidebar). */
export function getPageContentMaxWidth(sidebarWidth: number): number {
  return PAGE_LAYOUT_MAX_CONTENT_WIDTH - sidebarWidth;
}

/** Default content max width when the sidebar is expanded (desktop). */
export const PAGE_CONTENT_MAX_WIDTH = getPageContentMaxWidth(SIDEBAR_DIMENSIONS.EXPANDED_WIDTH);

const pageContentMaxWidthCss = `min(100%, var(${PAGE_CONTENT_MAX_WIDTH_CSS_VAR}, ${PAGE_CONTENT_MAX_WIDTH}px))`;

/** Centers page content on wide viewports while staying full width on small screens. */
const pageContentSx: SxProps<Theme> = {
  width: '100%',
  maxWidth: pageContentMaxWidthCss,
  minWidth: 0,
  mx: 'auto'
};

/** Detail pages (block editor, template editor, etc.). */
export const detailPageContentSx: SxProps<Theme> = pageContentSx;

/** List/grid pages (block library, templates list, etc.). */
export const listPageContentSx: SxProps<Theme> = pageContentSx;

/** Chromeless, host-sidebar-free editor routes (block editor, template editor): no cap, no centering. */
export const fullBleedPageContentSx: SxProps<Theme> = {
  width: '100%',
  maxWidth: '100%',
  minWidth: 0
};
